import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import React from 'react';

export interface MultiSelectComponentItem{
    key: any;
    value: string;
}

export interface IMultiSelectComponentProps {
    label: string;
    values: MultiSelectComponentItem[];
    onSelectionChange: (newValue:any[]) => void;
    selectedValues: any[];
    renderValue?: (key: any[]) => string;
    width?: string;
}

const MultiSelectComponent: React.FC<IMultiSelectComponentProps> = ({ label, values, onSelectionChange, selectedValues, renderValue, width }) => {
    const onUpdate = (event: SelectChangeEvent<any[]>) => {
        onSelectionChange(event.target.value as any[]);
    }

    const valueRenderer = renderValue ? renderValue : (a: any[]) => a.join(', ');

    return <FormControl sx={{ width: width ? width : "200px" }} size='small'>
        <InputLabel id={`select-${label}-label`}>{label}</InputLabel>
        <Select
            labelId={`select-${label}-label`}
            id={`select-${label}`}
            label={label}
            value={selectedValues}
            renderValue={valueRenderer}
            onChange={onUpdate}
            multiple={true}
            placeholder={label}
            size='small'
            variant='outlined'
            sx={{ 
                ".MuiOutlinedInput-notchedOutline": {
                    borderWidth: 0
                }}}
        >
            {values.map((v) => (<MenuItem key={`${label}-choice-${v.key}`} value={v.key}>
                <Checkbox checked={selectedValues.indexOf(v.key) > -1} />
                <ListItemText primary={v.value} />
            </MenuItem>))}
        </Select>
    </FormControl>
}

export default MultiSelectComponent